import { Component, OnInit, ViewChild} from '@angular/core';
import { Bomba } from 'src/app/models/bomba';
import { MqttControllerService } from 'src/app/services/mqtt-controller.service';
import { TimeService } from 'src/app/services/time.service';
import { TrendingService } from 'src/app/services/trending.service';

import { Variable } from "src/app/models/variable";

import { Chart } from "chart.js";
import { BehaviorSubject, forkJoin, Observable } from "rxjs";
import { TrendDataTime } from "src/app/data/trendings-data";
import { GeneralInfoService } from "src/app/services/general-info.service";

import * as Highcharts from "highcharts";


const MINUTES: number = 15;

@Component({
  selector: 'app-puerto',
  templateUrl: './puerto.component.html',
  styleUrls: ['./puerto.component.css']
})

export class PuertoComponent implements OnInit {

  bombas: Bomba[] = [
      {
          corrienteVarName: 'VAR_APP4_MOD43_MOD1',
          corrienteDisplayName: 'Bomba 1',
          corrienteLastValue: 0,
          corrienteLastDate: null,
          corrienteIsOldDate: true,
          corrienteClassState: 'off',
          tensionVarName: 'VAR_APP4_MOD43_MOD4',
          tensionDisplayName: 'Fase R',
          tensionLastValue: 0,
          tensionLastDate: null,
          tensionIsOldDate: true,
          tensionClassState: 'off',
      },
      {
          corrienteVarName: 'VAR_APP4_MOD43_MOD2',
          corrienteDisplayName: 'Bomba 2',
          corrienteLastValue: 0,
          corrienteLastDate: null,
          corrienteIsOldDate: true,
          corrienteClassState: 'off',
          tensionVarName: 'VAR_APP4_MOD43_MOD5',
          tensionDisplayName: 'Fase S',
          tensionLastValue: 0,
          tensionLastDate: null,
          tensionIsOldDate: true,
          tensionClassState: 'off',
      },
      {
          corrienteVarName: 'VAR_APP4_MOD43_MOD3',
          corrienteDisplayName: 'Bomba 3',
          corrienteLastValue: 0,
          corrienteLastDate: null,
          corrienteIsOldDate: true,
          corrienteClassState: 'off',
          tensionVarName: 'VAR_APP4_MOD43_MOD6',
          tensionDisplayName: 'Fase T',
          tensionLastValue: 0,
          tensionLastDate: null,
          tensionIsOldDate: true,
          tensionClassState: 'off',
      },
  ];



  variables: Variable[] = [
    {
      varName: "VAR_APP4_MOD43_DI1",
      displayName: "Detector de Hidrocarburo",
      lastValue: null,
      lastDate: null,
      isOldDate: false,
      classState: "",
    },
    {
      varName: "VAR_APP4_MOD43_DI3",
      displayName: "Pre aviso de incendio",
      lastValue: null,
      lastDate: null,
      isOldDate: false,
      classState: "",
    },
    {
      varName: "VAR_APP4_MOD43_DI4",
      displayName: "Incendio",
      lastValue: null,
      lastDate: null,
      isOldDate: false,
      classState: "",
    },
    {
      varName: "VAR_APP4_MOD43_DI2",
      displayName: "Estado de sistema eléctrico",
      lastValue: null,
      lastDate: null,
      isOldDate: false,
      classState: "",
    },
    {
      varName: "VAR_APP4_MOD43_DI5",
      displayName: "Detector de Trinchera",
      lastValue: null,
      lastDate: null,
      isOldDate: false,
      classState: "",
    },
  ];
  

  public currentDate: Date;
  private realTimeInterval;


  constructor(
      private mqttService: MqttControllerService,
      private trendingSvc: TrendingService,
      private timeSvc: TimeService
  ) { }


  ngOnInit() {
      setTimeout(() => {
          this.getValues();
      }, 1200);
      this.StartRealtimeTimer();
  }

  public getValues() {
      this.currentDate = new Date();
      let start: string = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate(), 0, 0, 0).toISOString().slice(0, -5);
      let end: string = this.currentDate.toISOString().slice(0, -5);

      this.bombas.forEach(bomba => {
          this.trendingSvc.getLastValue(2, bomba.corrienteVarName, start, end)
          .subscribe( trending => {
              bomba.corrienteLastValue = parseFloat(trending.value.toFixed(1));
              bomba.corrienteLastDate = new Date(trending.time);

              if (bomba.corrienteLastValue > 10) {
                  bomba.corrienteClassState = 'on';
              }
              if (this.timeSvc.checkDate(bomba.corrienteLastDate, this.currentDate, MINUTES)) {
                      bomba.corrienteIsOldDate = false;
              } else bomba.corrienteIsOldDate = true;
          });
          this.trendingSvc.getLastValue(2, bomba.tensionVarName, start, end)
          .subscribe( trending => {
              bomba.tensionLastValue = parseFloat(trending.value.toFixed(1));
              bomba.tensionLastDate = new Date(trending.time);

              if (bomba.tensionLastValue > 210) {
                  bomba.tensionClassState = 'on';
              }
              if (this.timeSvc.checkDate(bomba.tensionLastDate, this.currentDate, MINUTES)) {
                      bomba.tensionIsOldDate = false;
              } else bomba.tensionIsOldDate = true;
          });
      });
  

      this.variables.forEach((v) => {
        this.trendingSvc
          .getLastValue(2, v.varName, start, end)
          .subscribe((trending) => {
            v.lastValue = parseFloat(trending.value.toFixed(1));
            v.lastDate = new Date(trending.time);
    
            if (v.lastValue) {
              v.classState = "on";
            } else v.classState = "off";
            if (this.timeSvc.checkDate(v.lastDate, this.currentDate, MINUTES)) {
              v.isOldDate = false;
            } else v.isOldDate = true;

    });
  });
}

  ///////////////////////////////////////////////////////////////////////////////
  // TIMER PARA REALTIME
  ///////////////////////////////////////////////////////////////////////////////

  StartRealtimeTimer() {
      setInterval(() => {
          this.getValues();
      }, 120000);
  }
}
 









 